import Vue from 'vue';
import _ from 'lodash';
import {
    GET_GOODS_ORDER_LIST_REQUEST,
    GET_GOODS_ORDER_LIST_SUCCESS,
    GET_GOODS_ORDER_LIST_FAILURE,
    UPDATE_GOODS_ORDER_LIST_PARAMS,
    GOODS_ORDER_LIST_CONFIG_RESET,
} from '../mutationTypes';

const state = {
    listLoading: false,
    list: [],
    hasMore: true,
    params: {
        page: 1, // 当前页码
        pagesize: 20, // 单页加载量
        mobile: '', // 手机号
        orderId: '', // 订单id
    },
    pageCount: 1, // 总页数

};
const mutations = {
    // 商品订单
    [GET_GOODS_ORDER_LIST_REQUEST](state) {
        state.listLoading = true;
    },
    [GET_GOODS_ORDER_LIST_SUCCESS](state, res) {
        state.listLoading = false;
        state.pageCount = res.page_count;
        state.list = res.list;
    },
    [GET_GOODS_ORDER_LIST_FAILURE](state) {
        state.listLoading = false;
        state.pageCount = 1;
        state.list = [];
    },
    // 更新params参数
    [UPDATE_GOODS_ORDER_LIST_PARAMS](state, obj) {
        state.params[obj.k] = obj.val;
    },
    [GOODS_ORDER_LIST_CONFIG_RESET](state) {
        _.extend(state, _.cloneDeep({
            listLoading: false,
            list: [],
            hasMore: true,
            params: {
                page: 1,
                pagesize: 20,
                mobile: '', // 订单id
                orderId: '', // 手机号码
            },
        }));
    }
};
export const actions = {
    // 获取商品订单list
    async getGoodsOrderList({ commit }, reqParams) {
        commit(GET_GOODS_ORDER_LIST_REQUEST);

        const res = await Vue.$ajax.get('getGoodsOrder', reqParams);

        if (!res.errorType) {
            commit(GET_GOODS_ORDER_LIST_SUCCESS, res);
        } else {
            commit(GET_GOODS_ORDER_LIST_FAILURE);
        }
    },
    // 重置list
    resetGoodsOrder({ commit }) {
        commit(GOODS_ORDER_LIST_CONFIG_RESET);
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/goodsOrderList.js